import './locales/register'
import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

const List = lazy(() => import('./components/List'))
const PageVCardCreate = lazy(() =>
    import('./components/Create').then((m) => ({ default: m.PageVCardCreate }))
)
const Update = lazy(() => import('./components/Update'))
const VCardDetail = lazy(() => import('./components/Detail'))
const VCardPreview = lazy(() => import('./components/Preview'))

const VCard: RouteObject = {
    path: 'account',
    children: [
        {
            path: 'vcards',
            children: [
                {
                    path: '',
                    element: <List />,
                },
                {
                    path: 'new',
                    element: (
                        <PageVCardCreate
                            pageType="create"
                            refetchData={() => {}}
                        />
                    ),
                },
                {
                    path: 'preview/:uuid',
                    element: <VCardPreview />,
                },
                {
                    path: ':id',
                    children: [
                        {
                            path: 'edit',
                            element: <Update />,
                        },
                    ],
                },
            ],
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

const VCardPublic: RouteObject = {
    path: 'vcard',
    children: [
        {
            path: ':uuid',
            element: <VCardDetail />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export { VCard, VCardPublic }
